/** Resolve catalog images from MySQL-backed product rows only (no static fallbacks). */

import { productGalleryImagePaths } from '../productMediaUtils';
import { normalizeStockQty } from '../cart/cartUtils';

function imageFromProduct(p) {
  const paths = productGalleryImagePaths(p);
  return paths[0] || '';
}

function productMatchesGroup(p, groupKey) {
  const g = String(groupKey || '').trim().toLowerCase();
  if (!g) return false;
  const typ = String(p?.type || '').trim().toLowerCase();
  const sub = String(p?.subcategory || '').trim().toLowerCase();
  return typ === g || sub === g;
}

function scoreProductImage(p) {
  const paths = productGalleryImagePaths(p);
  if (!paths.length) return -1;
  let score = 1;
  if (paths.length > 1) score += 3;
  if (p?.is_visible !== false && p?.is_visible !== 0) score += 1;
  const stock = normalizeStockQty(p?.stock_qty);
  if (stock === null || stock > 0) score += 1;
  const price = Number(p?.price);
  if (Number.isFinite(price) && price >= 100) score += 1;
  return score;
}

export function firstProductImage(productList) {
  const list = productList || [];
  const hit = list.find((p) => imageFromProduct(p));
  return hit ? imageFromProduct(hit) : '';
}

/** Best representative image for a category tile (prefers multi-image, in-stock products). */
export function bestCategoryImage(productList) {
  const list = (productList || []).filter((p) => scoreProductImage(p) >= 0);
  if (!list.length) return '';
  const ranked = [...list].sort((a, b) => scoreProductImage(b) - scoreProductImage(a));
  return imageFromProduct(ranked[0]);
}

/** Manual cover from category meta, else auto from products. */
export function categoryShelfImage(categoryMeta, productList) {
  const chosen = String(categoryMeta?.cover_image ?? '').trim();
  if (chosen) return chosen;
  return bestCategoryImage(productList);
}

/** Manual cover from shop group meta, else auto from matching products. */
export function groupShelfImage(groupMeta, productList, groupKey) {
  const chosen = String(groupMeta?.cover_image ?? '').trim();
  if (chosen) return chosen;
  return thumbForGroup(productList, groupKey);
}

export function thumbForGroup(productList, groupKey) {
  const list = productList || [];
  if (groupKey) {
    const inGroup = list.filter((p) => productMatchesGroup(p, groupKey) && imageFromProduct(p));
    if (inGroup.length) {
      const ranked = [...inGroup].sort((a, b) => scoreProductImage(b) - scoreProductImage(a));
      return imageFromProduct(ranked[0]);
    }
  }
  return bestCategoryImage(list);
}
